export default __webpack_public_path__ + "static/media/anass.1212dfb4.png";